import api from 'API';
import axios from 'axios';
import getRoute from './getRoute';
import { store } from 'STORE';

export default (route, location, callback) => {
  const userType = store.getState().userToken.tokenType;
  if (userType !== 'aemi') {
    axios(api.users.profile.progress(userType).AXIOS('get')).then((response) => {
      callback({
        ...getRoute(response, route, location, userType),
        business_profile_id: response.data.business_profile_id,
        document_review_complete: response.data.document_review_complete,
      });
    });
  }
};
